import axios from "axios";
import * as Sentry from "@sentry/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;
let hasAlerted = false;
export const operationCancelled = "Operation canceled due to new request";

const httpClient = (baseURL = BASE_URL) => {
  const user = JSON.parse(localStorage.getItem("user"));

  let instance = axios.create({
    baseURL,
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      Authorization: user && user.accessToken && `Bearer ${user.accessToken}`,
      "x-client-name": process.env.REACT_APP_ENVIRONMENT,
    },
  });

  instance.interceptors.response.use(
    (response) => response,
    (err) => {
      if (err?.response?.status === 401) {
        console.error(JSON.stringify(err?.response));
        console.error(JSON.stringify(err?.response?.data?.errorMessage));
        if (!hasAlerted) {
          alert(
            "Your session has expired. Please press the user icon, log out and login again. If the message persists please contact customer support.",
          );
          // If user ignores alert, we don't want to keep alerting them.
          // To do: create a special component to log out  directly from the alert.
          hasAlerted = true;
        }
      } else if (err?.response?.status === 432) {
        // Invalid token
        console.error(JSON.stringify(err?.response?.data?.errorMessage));
        alert(err?.response?.data?.errorMessage);
      } else if (err?.message === operationCancelled) {
        // This is normal behavior. We don't want to alert the user.
      } else {
        // currently unclear whether we need to handle other errors. Error 500 sometimes happens due to hazard server overload.
      }

      Sentry.captureException(err);
      throw err;
    },
  );

  return instance;
};

export default httpClient;
